import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { toUpCase } from '../../../utils/misc';
import type { PaymentMessage } from '../types';
import styles from '../FileUploader.module.scss';

interface PaymentNoticesProps {
    messages: PaymentMessage[];
}

export const PaymentNotices: FC<PaymentNoticesProps> = ({ messages }) => {
    const { t } = useTranslation();

    const unpaidStatusLabel = t(
        'applications.fields.payment_status_unpaid',
        'не оплачено'
    );
    const unpaidStatusValues = [
        unpaidStatusLabel,
        t(
            'applications.fields.payment_status_partial',
            'частково оплачено'
        ),
    ];
    const notExpiredStatusValue = t(
        'applications.fields.payment_status_not_expired',
        'не прострочено'
    );

    if (!messages?.length) {
        return null;
    }

    return (
        <div className={styles.noticeList}>
            {messages.map((item, index) => {
                const needPaymentExpertise = unpaidStatusValues.includes(
                    item.expertise_status ?? ''
                );
                const needPaymentStateCollection = unpaidStatusValues.includes(
                    item.state_collection_status ?? ''
                );
                const needsPayment =
                    needPaymentExpertise || needPaymentStateCollection;

                const hasExpiredStatus =
                    item.not_expired_status !== notExpiredStatusValue &&
                    item.not_expired_status !== null;

                if (item.is_package && needsPayment) {
                    const packageCause = [
                        needsPayment ? toUpCase(unpaidStatusLabel) : '',
                        hasExpiredStatus
                            ? toUpCase(item.not_expired_status!)
                            : '',
                    ]
                        .filter(Boolean)
                        .join(' ');
                    const packageNotice = t(
                        'package_application',
                        'Пакетна заява ({{number}} - {{date}}) {{cause}}',
                        {
                            number: item.number ?? '',
                            date: item.date ?? '',
                            cause: packageCause,
                        }
                    );

                    return (
                        <div
                            className={styles.noticeItem}
                            key={item.number ?? index}
                        >
                            <span>{packageNotice}</span>
                        </div>
                    );
                }

                return (
                    <div
                        className={styles.noticeItem}
                        key={item.number ?? index}
                    >
                        <Fragment>
                            {needsPayment && (
                                <span className={styles.noticeBlock}>
                                    {toUpCase(unpaidStatusLabel)}
                                </span>
                            )}
                            {hasExpiredStatus && (
                                <span className={styles.noticeBlock}>
                                    {toUpCase(item.not_expired_status!)}
                                </span>
                            )}
                        </Fragment>
                    </div>
                );
            })}
        </div>
    );
};
